import { render, staticRenderFns } from "./UpdateScheduledMailDialog.vue?vue&type=template&id=13a4c242"
import script from "./UpdateScheduledMailDialog.vue?vue&type=script&lang=js"
export * from "./UpdateScheduledMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports